import React, { useEffect, useState } from 'react';

export const CountdownText = ({ timeoutInSeconds, onFinished, className }) => {
  const [remaining, setRemaining] = useState(timeoutInSeconds);

  useEffect(() => {
    setRemaining(timeoutInSeconds);
  }, [timeoutInSeconds]);

  useEffect(() => {
    if (remaining <= 0) {
      onFinished && onFinished();
      return;
    }
    const timer = window.setInterval(() => {
      setRemaining((prev) => prev - 1);
    }, 1000);

    return () => window.clearInterval(timer);
  }, [remaining, onFinished]);

  const mm = Math.floor(remaining / 60)
    .toString()
    .padStart(2, '0');
  const ss = (remaining % 60).toString().padStart(2, '0');

  return <span className={className}>{mm}:{ss}</span>;
};
